export default class Expense {
  constructor() {
    this.id = "";
    this.recipient = { id: "", content: "" };
    this.description = "";
    this.document = "";
    this.value = 0.0;
    this.dueDate = "";
    this.competenceDate = "";
    this.typePayment = { id: "", content: "" };
    this.chartOfAccounts = { id: "", content: "" };
    this.observation = "";
    this.genericId = "";
    this.statusName = "";
    this.rent = { id: "", content: "" };
  }

  update(data) {
    this.id = data.id;
    this.recipient = { id: data.recipient?.id, content: data.recipient?.content };
    this.description = data.description;
    this.document = data.document;
    this.value = data.value;
    this.dueDate = data.dueDateStr;
    this.competenceDate = data.competenceDateStr;
    this.statusName = data.statusName || data.StatusName || "";

    if (data.typePayment?.id)
      this.typePayment = { id: data.typePayment.id, content: data.typePayment.content };

    if (data.chartOfAccounts?.id)
      this.chartOfAccounts = { id: data.chartOfAccounts.id, content: data.chartOfAccounts.content };

    this.observation = data.observation;
    this.genericId = data.genericId;

    if (data.rent?.id)
      this.rent = { id: data.rent.id, content: data.rent.content };

  }
}
